import { render, staticRenderFns } from "./GroupWarnings.vue?vue&type=template&id=4592eded&"
import script from "./GroupWarnings.vue?vue&type=script&lang=js&"
export * from "./GroupWarnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports